/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useEffect } from "react";
import {
  ViedocButtonElement,
  ViedocMenuItemElement,
  ViedocSelectElement,
} from "../../../secure/elements/ViedocReactElements";
import { Field, Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import * as templateActions from "../../../store/actions/templateActions";
import * as emsActions from "../../../store/actions/emsActions";

import APP_CONST from "../../shared/constants";
import FileDownload from "../../components/shared/FileDownload/FileDownload";
import Loader from "../../components/shared/Loader/Loader";
import { getMilestoneGroupLabel } from "../../../../utils/utilsHelper";

const EmsRepository = ({ setShowPlaceholderComponent }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { countryList, siteList, milestoneGroupList, mileStoneListWithGroup } =
    useSelector((store) => store.template);

  const { latestArchiveInfo, isArchiveLoading, isCancelBeforeSuccess } =
    useSelector((store) => store.ems);
  const { tmfList } = useSelector((store) => store.zone);

  let tmfSideMapValue = [];

  tmfList?.map((tmf) => {
    if (tmf.text === "Sponsor") {
      tmfSideMapValue.push({
        value: "Sponsor",
        label: t("ARCHIVE.FORMLABEL_SPONSOR"),
      });
    }
    if (tmf.text === "Investigator") {
      tmfSideMapValue.push({
        value: "Investigator",
        label: t("ARCHIVE.FORMLABEL_INVESTIGATOR"),
      });
    }
  });
  let countryPayload,
    sitePayload,
    milestoneListPayload,
    milestoneGroupPayload,
    tmfSidePayload;

  const countryMapping = [
    { value: "All countries", label: t("ARCHIVE.PLACEHOLDER_ALLCOUNTRY") },
    ...countryList.map((country) => ({
      value: country.country,
      label: country.country,
      code: country.countryCode,
    })),
  ];

  const siteMapping = [
    { value: "All sites", label: t("ARCHIVE.PLACEHOLDER_ALLSITES") },
    ...siteList.map((siteName) => ({
      value: siteName.siteName,
      label: siteName.siteName,
      code: siteName.guid,
    })),
  ];

  const milestoneGroupData = [
    {
      value: "All milestones",
      label: t("ARCHIVE.PLACEHOLDER_ALLMILESTONES"),
      code: "ALL",
    }
  ];

  const milestoneMapping = [
    ...milestoneGroupData,
    ...(mileStoneListWithGroup?.map((milestone) => ({
      value: milestone.name ? milestone.name : milestone.label,
      label: milestone.name ? milestone.name : getMilestoneGroupLabel(milestone.label),
      code: milestone.id ? milestone.id : milestone.label,
    })) || []),
  ];

  const tmfSideMapping = [
    ...APP_CONST.TMF_SIDE_LIST.map((tmfSide) => ({
      value: tmfSide.value,
      label: tmfSide.label,
      code: tmfSide.value,
    })),
  ];

  let tmfSideFilter = [
    tmfSideMapValue?.[0]?.value,
    tmfSideMapValue?.[1]?.value,
  ];

  let trialLevelDocs = [
    {
      value: "Trial Level",
      label: t("ARCHIVE.PLACEHOLDER_TRIALLEVEL"),
    },
  ];
  let trialLevelDocuments = [trialLevelDocs[0]?.value];
  let countryLevelDocuments = [countryMapping[0]?.value];
  let siteLevelDocuments = [siteMapping[0]?.value];
  let milestoneFilter = [milestoneMapping[0]?.value];

  const tmfSideValue = [
    {
      className: "archive-dropdown pt-20",
      label: t("ARCHIVE.FORMLABEL_TMFSIDE"),
      name: "tmfSide",
      size: "small",
      variant: "outline",
      placeholder: "Select values",
      mappingValues: tmfSideMapValue,
    },
  ];

  const trailLevelValue = [
    {
      className: "archive-dropdown",
      label: t("ARCHIVE.FORMLABEL_TRIALLEVELDOC"),
      name: "trial",
      size: "small",
      variant: "outline",
      placeholder: "Select values",
      mappingValues: trialLevelDocs,
    },
  ];

  const countryLevelValue = [
    {
      className: "archive-dropdown",
      label: t("ARCHIVE.FORMLABEL_COUNTRYLEVELDOC"),
      name: "country",
      size: "small",
      variant: "outline",
      placeholder: "Select values",
      mappingValues: countryMapping,
    },
  ];

  const siteLevelValue = [
    {
      className: "archive-dropdown",
      label: t("ARCHIVE.FORMLABEL_SITELEVELDOC"),
      name: "site",
      size: "small",
      variant: "outline",
      placeholder: "Select values",
      mappingValues: siteMapping,
    },
  ];

  const handleMultiSelect = (event, form, name) => {
    const { value } = event.target;

    form.change(name, value);

    if (name === "trial") {
      trialLevelDocuments = value;
    } else if (name === "country") {
      countryLevelDocuments = value;
      countryPayload = countryMapping
        .map((country) => {
          if (countryLevelDocuments.includes(country.value)) {
            return country.code;
          }
        })
        .filter((value) => value !== undefined);
    } else if (name === "site") {
      siteLevelDocuments = value;
      sitePayload = siteMapping
        .map((site) => {
          if (siteLevelDocuments.includes(site.value)) {
            return site.code;
          }
        })
        .filter((value) => value !== undefined);
    } else if (name === "tmfSide") {
      tmfSideFilter = value;
      tmfSidePayload = tmfSideMapping.map((tmfSide) => {
        if (tmfSideFilter.includes(tmfSide.value)) {
          return tmfSide.code;
        }
      });
    } else {
      milestoneFilter = value;
      milestoneGroupPayload = milestoneMapping
        .map((milestone) => {
          if (milestoneFilter.includes(milestone.value)) {
            return milestone.code;
          }
        })
        .filter(
          (value) =>
            value !== undefined &&
            ["ALL","Start Up", "Study Conduct", "Close Out", "Other"].includes(value)
        );
      milestoneListPayload = milestoneMapping
        .map((milestone) => {
          if (milestoneFilter.includes(milestone.value)) {
            return milestone.code;
          }
        })
        .filter(
          (value) =>
            value !== undefined &&
            !["Start Up", "Study Conduct", "Close Out", "Other"].includes(value)
        );
    }
  };

  const onSubmit = () => {
    setShowPlaceholderComponent(true);
    const fileGenerationPayload = {
      trial: trialLevelDocuments.includes(trialLevelDocs[0].value)
        ? ["Trial level"]
        : [],
      countries: countryPayload || ["ALL"],
      sites: sitePayload || ["ALL"],
      milestone: milestoneListPayload || ["ALL"],
      milestoneGroup: milestoneGroupPayload || ["ALL"],
      tmfside: tmfSideFilter?.filter((item) => item) || ["Sponsor"],
      category: APP_CONST.TEXT_ARCHIVE,
    };
    dispatch(emsActions.generateCompleteAuditTrail(fileGenerationPayload));
    dispatch(emsActions.setInitialArchiveCancel(false));
  };

  /* API call to download the generated file available
   * @params archiveInfo from Redux is passed as arguments
   */
  const downloadFileHandler = (fileDetailObj) => {
    const requestPayload = {
      id: fileDetailObj.id,
      filename: fileDetailObj.filename,
      category: fileDetailObj.category,
    };
    dispatch(templateActions.downloadCompleteAuditTrail(requestPayload));
  };

  const resetHandler = (form) => {
    tmfSideFilter = [tmfSideMapValue?.[0]?.value, tmfSideMapValue?.[1]?.value];
    trialLevelDocuments = [trialLevelDocs[0].value];
    countryLevelDocuments = [countryMapping[0].value];
    siteLevelDocuments = [siteMapping[0].value];
    milestoneFilter = [milestoneMapping[0].value];
    form.reset(APP_CONST.dataPayload);
  };

  const selectedValue = (name) => {
    if (name === "trial") {
      return trialLevelDocuments;
    } else if (name === "tmfSide") {
      return tmfSideFilter;
    } else if (name === "country") {
      return countryLevelDocuments;
    } else if (name === "site") {
      return siteLevelDocuments;
    } else {
      return milestoneFilter;
    }
  };

  //Function to pass as a component type for Field component of react-final-form
  const selectInput = ({
    formChange,
    mappingValues,
    size,
    variant,
    placeholder,
    fieldname,
  }) => (
    <ViedocSelectElement
      name={fieldname}
      size={size}
      variant={variant}
      value={selectedValue(fieldname)}
      multiple
      placeholder={placeholder}
      onChange={formChange}
    >
      {mappingValues.map((option) => (
        <ViedocMenuItemElement
          selected={
            APP_CONST.MULTISELECT_VALUES.includes(option.value) ? true : null
          }
          value={option.value}
          key={option.value}
          className={
            fieldname === APP_CONST.TEXT_MILESTONE &&
            !(
              milestoneGroupList?.result?.includes(option.value) ||
              option.value === APP_CONST.TEXT_ALL_MILESTONE
            )
              ? "menu-list-separation"
              : ""
          }
        >
          {option.label}
        </ViedocMenuItemElement>
      ))}
    </ViedocSelectElement>
  );

  /* Render the Cancel and Generate button in return statement
   * @params pristine, invalid and form are passed as arguments
   */
  const renderFormButtons = (pristine, invalid, form) => {
    return (
      <div className="archive-box">
        <ViedocButtonElement
          size="small"
          variant="neutral"
          disabled={pristine || invalid}
          class="mr-10 pl-20"
          onClick={() => resetHandler(form)}
          title={t("ARCHIVE.BUTTON_RESET")}
        >
          {t("ARCHIVE.BUTTON_RESET")}
        </ViedocButtonElement>
        <ViedocButtonElement
          size="small"
          variant="success"
          disabled={invalid}
          onClick={onSubmit}
          title={t("ARCHIVE.BUTTON_GENERATE")}
        >
          {t("ARCHIVE.BUTTON_GENERATE")}
        </ViedocButtonElement>
      </div>
    );
  };

  useEffect(() => {
    if (isCancelBeforeSuccess) return;
    dispatch(templateActions.getCountry());
    dispatch(templateActions.getSite());
    dispatch(templateActions.getMilestoneDropDownData());
    dispatch(templateActions.getMilestoneGroup());
    dispatch(templateActions.getTimeFormat());
  }, []);

  const renderDocumentFilters = (form) => {
    return (
      <>
        {tmfSideValue.map((fieldValue) => (
          <div key={fieldValue.name} className={fieldValue.className}>
            <label>{fieldValue.label}:</label>
            <Field
              fieldname={fieldValue.name}
              name={fieldValue.name}
              size={fieldValue.size}
              variant={fieldValue.variant}
              component={selectInput}
              placeholder={fieldValue.placeholder}
              formChange={(event) =>
                handleMultiSelect(event, form, fieldValue.name)
              }
              mappingValues={fieldValue.mappingValues}
            />
          </div>
        ))}

        {trailLevelValue.map((fieldValue) => (
          <div key={fieldValue.name} className={fieldValue.className}>
            <label>{fieldValue.label}:</label>
            <Field
              fieldname={fieldValue.name}
              name={fieldValue.name}
              size={fieldValue.size}
              variant={fieldValue.variant}
              component={selectInput}
              placeholder={fieldValue.placeholder}
              formChange={(event) =>
                handleMultiSelect(event, form, fieldValue.name)
              }
              mappingValues={fieldValue.mappingValues}
            />
          </div>
        ))}

        {countryLevelValue.map((fieldValue) => (
          <div key={fieldValue.name} className={fieldValue.className}>
            <label>{fieldValue.label}:</label>
            <Field
              fieldname={fieldValue.name}
              name={fieldValue.name}
              size={fieldValue.size}
              variant={fieldValue.variant}
              component={selectInput}
              placeholder={fieldValue.placeholder}
              formChange={(event) =>
                handleMultiSelect(event, form, fieldValue.name)
              }
              mappingValues={fieldValue.mappingValues}
            />
          </div>
        ))}

        {siteLevelValue.map((fieldValue) => (
          <div key={fieldValue.name} className={fieldValue.className}>
            <label>{fieldValue.label}:</label>
            <Field
              fieldname={fieldValue.name}
              name={fieldValue.name}
              size={fieldValue.size}
              variant={fieldValue.variant}
              component={selectInput}
              placeholder={fieldValue.placeholder}
              formChange={(event) =>
                handleMultiSelect(event, form, fieldValue.name)
              }
              mappingValues={fieldValue.mappingValues}
            />
          </div>
        ))}
      </>
    );
  };

  const renderMilestoneFilter = (form) => {
    return (
      <div className="archive-dropdown">
        <label>{t("ADMIN.ADMINTAB_MILESTONE")}:</label>
        <Field
          fieldname="milestones"
          name="milestones"
          size="small"
          variant="outline"
          component={selectInput}
          placeholder="Select values"
          formChange={(event) => handleMultiSelect(event, form, "milestones")}
          mappingValues={milestoneMapping}
        />
      </div>
    );
  };

  return (
    <>
      {isArchiveLoading ? (
        <Loader />
      ) : (
        <FileDownload
          downloadFileHandler={downloadFileHandler}
          category={APP_CONST.TEXT_ARCHIVE}
          latestArchiveInformation={latestArchiveInfo}
        />
      )}
      <Form
        onSubmit={onSubmit}
        mutators={{}}
        initialValues={APP_CONST.dataPayload}
        render={({ handleSubmit, pristine, invalid, form }) => (
          <form onSubmit={handleSubmit}>
            <div className="archive-content pl-30 pt-30">
              <h3>{t("ARCHIVE.TEXT_GENERATENEWFILE")}</h3>
              <h5 className="light-grey pt-20">{t("ARCHIVE.TEXT_INCLUDE")}</h5>

              {renderDocumentFilters(form)}

              <div className="archive-dropdown pt-30">
                <h5 className="light-grey pt-20">
                  {t("ARCHIVE.FORMLABEL_FILTERBY")}
                </h5>
              </div>

              {renderMilestoneFilter(form)}
            </div>
            {renderFormButtons(pristine, invalid, form)}
          </form>
        )}
      />
    </>
  );
};

export default EmsRepository;
